import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'post-image' ? section?.media?.primary : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseMarketAnalysisHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
  };
};

export const parseMarketAnalysisPostsSettingsContent = (page) => {
  const section = getSection(page, 'posts');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const categories = (fields.categories || '')
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean);

  if (categories.length === 0) {
    return null;
  }

  return { categories };
};

export const parseMarketAnalysisMarketInsightsContent = (page) => {
  const section = getSection(page, 'market-insights');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    buttonText: fields.buttonText || 'Subscribe',
    privacy: {
      text: fields.privacyText || '',
      linkText: fields.privacyLinkText || 'privacy policy',
      linkUrl: fields.privacyLinkUrl || '/privacy',
    },
  };
};

export const parseMarketAnalysisInsightToStrategyContent = (page) => {
  const section = getSection(page, 'insight-to-strategy');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/contact',
    },
  };
};

export const parseMarketAnalysisPostSummary = (post) => ({
  id: post.id,
  slug: post.slug,
  category: post.category || '',
  title: post.title || '',
  excerpt: post.excerpt || '',
  author: post.author || '',
  date: post.date || '',
  featured: Boolean(post.featured),
  image: post.imageUrl ? resolveMediaUrl(post.imageUrl) : '',
  avatar: post.avatarUrl ? resolveMediaUrl(post.avatarUrl) : '',
});

export const parseMarketAnalysisPostPage = (page) => {
  const postSection = getSection(page, 'post');
  const contentSection = getSection(page, 'content');

  if (!postSection) {
    return null;
  }

  const fields = postSection.fields || {};
  if (!fields.title) {
    return null;
  }

  const contentFields = contentSection?.fields || {};

  return {
    slug: page.slug,
    category: fields.category || '',
    title: fields.title,
    excerpt: fields.excerpt || '',
    author: fields.author || '',
    date: fields.date || '',
    featured: (fields.featured || 'false').toLowerCase() === 'true',
    image: getMediaUrl(postSection, 'post-image'),
    avatar: getMediaUrl(postSection, 'avatar'),
    lead: contentFields.lead || '',
    body: contentFields.body || '',
  };
};
